import moment from "moment";
import React, { PropTypes } from "react";
import { FormattedMessage, intlShape } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Field,
  change as changeFieldValue,
  formValueSelector,
  reduxForm,
} from "redux-form";

import MessageBox from "../../../../common/MessageBox";
import {
  CheckboxInput,
  IntlFieldGroup,
  SelectInput,
  TextInput,
} from "../../../../common/form";
import {
  FixedTypeCoverage,
  FormulaTypeCoverage,
  PriceListTypeCoverage,
} from "./priceCalculation";

import validationUtils from "../../../../../utils/ValidationUtils";
import * as dataActions from "../../../../../utils/data/dataActions";
import {
  BILLING_PERIODS,
  CLASSES,
  CLIENT_COVERAGES,
  GUARANTEES,
  INSURERS,
} from "../../../../../utils/data/models";

import store from "../../../../../store";
import { DIRECTOR, FINTECH } from "../../../../../utils/Roles";
import userHasAccess from "../../../../../utils/userHasAccess";
import {
  FIXED,
  FORMULA,
  MEMBER,
  MEMBER_MULTIPLIER,
  PRICE_LIST,
} from "../../../admin/guarantees/enums/guaranteeTypes";
import { TERMINATED } from "../../enums/clientStatusTypes";
import { SELF_INSURED } from "../../enums/insuranceStatuses";
import { CLIENT_COVERAGES_VALIDATION_RULES } from "./clientCoveragesValidationRules";
import clientCoverageTaxTypes from "./enums/clientCoverageTaxTypes";
import clientCoverageTypes from "./enums/clientCoverageTypes";
import { ACTIVE, IMPLEMENTATION, INACTIVE } from "./enums/clientCoveragesStatusTypes";
import SurplusAllocationTable from "./priceCalculation/SurplusAllocationTable";
import { RECURRING } from "../../enums/billingPeriodTypes";
import { MAX_DECIMAL } from "../../../../common/Configurations/DecimalConfiguration";

const formName = "clientCoverage";

class BasicClientCoveragesFields extends React.Component {
  static generateLocalizedRules(model) {
    let rules = {};
    let localRules = {};
    let clientStatusType = localStorage.getItem("clientStatusType");
    let newRules = { ...CLIENT_COVERAGES_VALIDATION_RULES };

    CLIENT_COVERAGES.localizedFields.map((field) => {
      Object.keys(model.localizations).map((locale) => {
        const fieldName = `localizations['${locale}'].${field}`;
        newRules[fieldName] = newRules[field];
      });
    });
    CLIENT_COVERAGES.localizedFields.map((field) => {
      delete newRules[field];
    });

    Object.keys(model).forEach((key) => {
      if (key == "policyNumber") {
        if (
          clientStatusType == IMPLEMENTATION.value &&
          model.policyNumber &&
          model.policyNumber.length > 0
        ) {
          rules[`policyNumber`] = {
            minLength: {
              value: 2,
            },
            stringSameCharacters: {
              value: true,
            },
            noSpacesBeginning: {
              value: true,
            },
            noSpacesEnd: {
              value: true,
            },
          };
        } else if (
          clientStatusType == IMPLEMENTATION.value &&
          !model.policyNumber
        ) {
          rules[`policyNumber`] = {};
        } else {
          rules[`policyNumber`] = {
            isRequiredTrim: {
              value: true,
            },
            minLength: {
              value: 2,
            },
            stringSameCharacters: {
              value: true,
            },
            noSpacesBeginning: {
              value: true,
            },
            noSpacesEnd: {
              value: true,
            },
          };
        }
      }
    });
    localRules = { ...newRules, ...rules };
    return localRules;
  }

  constructor(props) {
    super(props);

    this.state = {
      guaranteeType: "",
      formulaDenominator: null,
      formulaType: "",
      initialInsurerValue: "",
      policyNumberAvailable: false,
      clientMev: false,
      isAfterClientLastActive: null,
      startDate: null,
      existantCoverage: false,
      isInErrorState: false,
    };

    this.viewOnlyClientCoveragesForImplementation = !userHasAccess(DIRECTOR);
    this.viewOnlyClientCoveragesForActive = !userHasAccess(DIRECTOR);
    this.viewOnlyClientCoveragesForTermination = !userHasAccess(FINTECH);

    this.generateLocalizedFields = this.generateLocalizedFields.bind(this);
    this.onBillingPeriodSelect = this.onBillingPeriodSelect.bind(this);
    this.onFormulaTypeSelect = this.onFormulaTypeSelect.bind(this);
    this.onGuaranteeSelect = this.onGuaranteeSelect.bind(this);
    this.onInsurerSelect = this.onInsurerSelect.bind(this);
    this.getCoverageType = this.getCoverageType.bind(this);
    this.onChangeClientRate = this.onChangeClientRate.bind(this);
    this.onChangeCommission = this.onChangeCommission.bind(this);
    this.updateProviderRate = this.updateProviderRate.bind(this);
    this.onChangePolicyNumber = this.onChangePolicyNumber.bind(this);
    this.onChangeRate = this.onChangeRate.bind(this);
    this.updateClientReserveRate = this.updateClientReserveRate.bind(this);
    this.getViewOnlyForClientStatusType = this.getViewOnlyForClientStatusType.bind(this);
  }

  getChildContext() {
    return {
      scene: this.props.scene,
    };
  }

  componentWillMount() {
    const today = moment.utc().startOf("day").toISOString();
    const { authLanguageCode, dataActions, initialValues } = this.props;
    let clientStatusType = localStorage.getItem("clientStatusType");
    if (initialValues.guarantee) {
      this.setState({
        guaranteeType: initialValues.guarantee.guaranteeType,
        formulaDenominator: initialValues.guarantee.formulaDenominator,
      });
      this.props.changeFieldValue(
        formName,
        "formulaDenominator",
        initialValues.guarantee.formulaDenominator
      );
    }
    if (initialValues.formulaType) {
      this.setState({ formulaType: initialValues.formulaType });
    }
    if (clientStatusType == IMPLEMENTATION.value) {
      this.setState({ clientMev: true, policyNumberAvailable: true });
    }
    const guaranteesFilters = [];
    const guaranteesSortBy = [`localizations.name:asc`];
    dataActions
      .getDataList(GUARANTEES, 0, 0, "", guaranteesSortBy, guaranteesFilters)
      .then((data) => {
        if (initialValues.guaranteeId && data.type == "GET_DATA_LIST_SUCCESS") {
          const guaranteesList = data.payload.data.items;
          const guarantee = guaranteesList.find(
            (guarantee) => guarantee.guaranteeId == initialValues.guaranteeId
          );
          this.props.changeFieldValue(
            formName,
            "guaranteeName",
            guarantee.localizations[authLanguageCode].name
          );
        }
      });

    const insurersFilters = [];
    const insurersSortBy = [`localizations.name:asc`];
    if (initialValues.clientInsuranceStatusType != SELF_INSURED.value) {
      insurersFilters.unshift("isVisible==true");
    }
    dataActions
      .getDataList(INSURERS, 0, 0, "", insurersSortBy, insurersFilters)
      .then((data) => {
        if (initialValues.insurerId && data.type == "GET_DATA_LIST_SUCCESS") {
          const insurersList = data.payload.data.items;
          const insurer = insurersList.find(
            (insurer) => insurer.insurerId == initialValues.insurerId
          );
          this.props.changeFieldValue(
            formName,
            "insurerName",
            insurer.localizations[authLanguageCode].name
          );
        }
      });

    let filters = [`clientId==${this.props.initialValues.clientId}`];
    if (this.props.clientBillingPeriodType === RECURRING.value) {
      filters.push(`startDate=lt=${today}`);
    }
    this.props.dataActions.getDataList(
      BILLING_PERIODS,
      0,
      0,
      "",
      ["startDate:desc"],
      filters
    );

    const classesFilters = [
      `clientId==${initialValues.clientId}`,
      CLASSES.archiveFilter,
    ];
    const classesSortBy = [`name:asc`];
    dataActions.getDataList(CLASSES, 0, 0, "", classesSortBy, classesFilters);
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.add && nextProps.clientLastActiveDate) {
      if (nextProps.active.startDate !== this.state.startDate) {
        this.setState({ startDate: nextProps.active.startDate }); // Initial start date of coverage.
        if (
          moment(nextProps.active.startDate).isAfter(
            nextProps.clientLastActiveDate
          )
        ) {
          this.setState({ isInErrorState: true });
        }
      }
    }
  }
  componentDidUpdate(prevProps) {
    if (this.props.clientStatusType === INACTIVE.value) {
      const {
        billingPeriodId,
        clientLastActiveDate,
        billingPeriodsList,
        add,
      } = this.props;
      if (this.props.clientLastActiveDate) {
        const billingPeriod = billingPeriodsList.find(
          (bp) => bp.billingPeriodId == billingPeriodId
        );

        let dateObj = new Date();
        dateObj.setMonth(dateObj.getMonth() + 1, 1);
        dateObj = dateObj.toISOString().split("T")[0];

        let applicableStartDate = billingPeriod
          ? billingPeriod.startDate
          : dateObj;
        if (
          !add &&
          this.state.startDate &&
          !billingPeriod &&
          billingPeriodId !== "null"
        ) {
          applicableStartDate = this.state.startDate; // Existing coverages have a start date
        }
        const dateChangeConditions =
          prevProps.billingPeriodId != billingPeriodId ||
          (billingPeriodId === "null" &&
            prevProps.billingPeriodId !== billingPeriodId);
        const modificationConditions =
          !add &&
          applicableStartDate &&
          this.state.isAfterClientLastActive === null;
        if (dateChangeConditions || modificationConditions) {
          if (moment(applicableStartDate).isSameOrAfter(clientLastActiveDate)) {
            this.props.setBlockInactivationSubmission(true);
            this.setState({ isAfterClientLastActive: true });
          } else {
            this.props.setBlockInactivationSubmission(false);
            this.setState({ isAfterClientLastActive: false });
          }
        }
      }
    }
  }

  componentWillUnmount() {
    this.props.dataActions.clearDataList(BILLING_PERIODS);
    this.props.dataActions.clearDataList(GUARANTEES);
    this.props.dataActions.clearDataList(INSURERS);
    this.props.setBlockInactivationSubmission(false);
  }

  getViewOnlyForClientStatusType() {
    const { clientStatusType } = this.props;

    switch (clientStatusType) {
      case IMPLEMENTATION.value:
        return this.viewOnlyClientCoveragesForImplementation;
      case ACTIVE.value:
      case INACTIVE.value:
        return this.viewOnlyClientCoveragesForActive;
      case TERMINATED.value:
        return this.viewOnlyClientCoveragesForTermination;
    }
  }

  generateLocalizedFields() {
    return CLIENT_COVERAGES.localizedFields.map((field) => {
      return (
        <IntlFieldGroup
          key={field}
          field={field}
          labelKey={`clientCoverages.form.${field}`}
          required={true}
          isArchived={this.props.isArchived}
          localizations={this.props.initialValues.localizations}
          readOnly={this.state.isAfterClientLastActive}
        />
      );
    });
  }

  onChangePolicyNumber(e) {
    let name = "policyNumber";
    const policyNumber = e.target.value;
    if (!this.state.policyNumberAvailable) {
      this.props.changeFieldValue(formName, name, policyNumber);
    }
  }

  onBillingPeriodSelect(e) {
    const billingPeriodId = e.target.value;
    const billingPeriodsList = this.props.billingPeriodsList || [];
    const startDate = (
      billingPeriodsList.find(
        (period) => period.billingPeriodId == billingPeriodId
      ) || {}
    ).startDate;

    this.props.changeFieldValue(
      formName,
      "startDate",
      startDate ? startDate : null
    );
  }

  onGuaranteeSelect(e) {
    const { authLanguageCode, guaranteesList } = this.props;
    const guarantee = guaranteesList.find(
      (guarantee) => guarantee.guaranteeId == e.target.value
    );

    this.props.changeFieldValue(
      formName,
      "guaranteeType",
      guarantee.guaranteeType
    );
    this.props.changeFieldValue(
      formName,
      "guaranteeName",
      guarantee.localizations[authLanguageCode].name
    );
    this.props.changeFieldValue(
      formName,
      "formulaDenominator",
      guarantee.formulaDenominator
    );
    if (guarantee.guaranteeType == FORMULA.value) {
      this.props.changeFieldValue(formName, "formulaType", "FIXED");
    }
    return this.setState({
      guaranteeType: guarantee.guaranteeType,
      formulaDenominator: guarantee.formulaDenominator,
    });
  }

  onInsurerSelect(e) {
    const { authLanguageCode, insurersList, initialValues } = this.props;
    let clientStatusType = localStorage.getItem("clientStatusType");
    const insurer = insurersList.find(
      (insurer) => insurer.insurerId == e.target.value
    );
    this.setState({
      initialInsurerValue: initialValues.insurerId,
    });
    this.props.changeFieldValue(
      formName,
      "insurerName",
      insurer.localizations[authLanguageCode].name
    );
    if (clientStatusType != IMPLEMENTATION.value) {
      this.setState({
        policyNumberAvailable:
          this.state.initialInsurerValue != insurer.insurerId,
      });
    } else this.setState({ policyNumberAvailable: true });
  }

  onFormulaTypeSelect(e) {
    return this.setState({ formulaType: e.target.value });
  }

  getCoverageType(type) {
    switch (type) {
      case MEMBER.value:
        case MEMBER_MULTIPLIER.value:
        return (
          <h5>
            <FormattedMessage id="clientCoverages.form.memberCoverageMessage" />
          </h5>
        );

      case FIXED.value:
        return (
          <FixedTypeCoverage
            ratePeriodType={this.props.ratePeriodType}
            onChangeClientRate={this.onChangeClientRate}
            readOnly={this.state.isAfterClientLastActive}
          />
        );

      case PRICE_LIST.value: {
        return (
          this.props.gotClasses && (
            <PriceListTypeCoverage
              initValues={this.props.initialValues}
              classes={this.props.classesList}
              ratePeriodType={this.props.ratePeriodType}
              onChangeClientRate={this.onChangeClientRate}
              readOnly={this.state.isAfterClientLastActive}
              changeFieldValue={this.props.changeFieldValue}
            />
          )
        );
      }
      case FORMULA.value:
        return (
          <FormulaTypeCoverage
            volume={this.state.formulaDenominator}
            onFormulaTypeSelect={this.onFormulaTypeSelect}
            formulaType={this.state.formulaType}
            languageCode={this.props.authLanguageCode}
            ratePeriodType={this.props.ratePeriodType}
            onChangeClientRate={this.onChangeClientRate}
            readOnly={this.state.isAfterClientLastActive}
          />
        );

      default:
        return <div />;
    }
  }

  onChangeClientRate(fieldName, event, clientRate) {
    const { commissionRate } = this.props;
    const { guaranteeType } = this.state;

    if (guaranteeType === PRICE_LIST.value) {
      const targetName = fieldName.replace(/ClientRate/i, (match) => {
        if (match[0] === "C") {
          return "ProviderRate";
        }
        return "providerRate";
      });

      this.updateProviderRate(clientRate, commissionRate, targetName);
    } else {
      this.updateProviderRate(clientRate, commissionRate);
    }
  }

  onChangeCommission(event, commissionRate) {
    const { clientRate } = this.props;
    const { guaranteeType } = this.state;

    if (guaranteeType === PRICE_LIST.value) {
      const selector = formValueSelector(formName);

      // Hardcoded coverageTypes
      clientCoverageTypes.map((type) => {
        const clientRate = selector(store.getState(), type.idClient);
        this.updateProviderRate(clientRate, commissionRate, type.idProvider);
      });

      // Dynamic coverageTypes
      const prices = selector(store.getState(), "prices");
      prices.map((price, index) => {
        const clientRate = price.clientRate;
        const fieldName = `prices[${index}].providerRate`;

        this.updateProviderRate(clientRate, commissionRate, fieldName);
      });
    } else {
      this.updateProviderRate(clientRate, commissionRate);
    }
  }

  updateProviderRate(
    clientRate = 0,
    commissionRate = 0,
    fieldName = "providerRate"
  ) {
    const { changeFieldValue } = this.props;
    const providerRate = clientRate - clientRate * (commissionRate / 100);

    changeFieldValue(formName, fieldName, providerRate.toFixed(MAX_DECIMAL));
  }

  onChangeRate(fieldName, event, markUpRate) {
    const targetName = "clientReserveRate";

    this.updateClientReserveRate(markUpRate, targetName);
  }

  updateClientReserveRate(clientRate = 0, fieldName = "clientReserveRate") {
    const { changeFieldValue } = this.props;
    const clientReserveRate = 100 - clientRate;

    changeFieldValue(formName, fieldName, clientReserveRate.toFixed(MAX_DECIMAL));
  }

  render() {
    const billingPeriodsList = this.props.billingPeriodsList || [];
    const maximumRetroactiveDate = this.props.maximumRetroactiveDate;
    const guaranteesList = this.props.guaranteesList || [];
    const insurersList = this.props.insurersList || [];
    const potentialInactivationErrKey = this.props.add
      ? "clientCoverages.errors.newClientCoverageInactivationError"
      : "clientCoverages.errors.modifyClientCoverageInactivationError";

    const isClientRecurring = this.props.clientBillingPeriodType == RECURRING.value;

    let billingPeriods = [];
    /** Pass empty options array to field as long as maximum retroactive date query is not done. 
      * if we pass an array that is not formatted well for this field, we will get an error.
    */
    if (this.props.fetchingMaximumRetroactiveDate === false) {
      billingPeriods = billingPeriodsList;
      billingPeriods = billingPeriods
        .filter(bp => !maximumRetroactiveDate || bp.startDate >= maximumRetroactiveDate)
        .map(billingPeriod => ({
          value: billingPeriod.billingPeriodId,
          text: billingPeriod.localizations[this.props.authLanguageCode].name,
        }));

      if (isClientRecurring) {
        billingPeriods.unshift({
          value: null,
          text: <FormattedMessage id="clientCoverages.form.nextBillingPeriod" />,
        });
      }
    }

    const guaranteesFilter = (guarantee) => {
      return (
        guarantee.guaranteeId == this.props.initialValues.guaranteeId ||
        guarantee.isArchived == false
      );
    };
    const guarantees = guaranteesList
      .filter(guaranteesFilter)
      .map((guarantee) => {
        return {
          value: guarantee.guaranteeId,
          text: guarantee.localizations[this.props.authLanguageCode].name,
        };
      });
    const insurersFilter = (insurer) => {
      return (
        insurer.insurerId == this.props.initialValues.insurerId ||
        insurer.isArchived == false
      );
    };
    const insurers = insurersList.filter(insurersFilter).map((insurer) => {
      return {
        value: insurer.insurerId,
        text: insurer.localizations[`${this.props.authLanguageCode}`].name,
      };
    });
    const isAfterClientLastActive = this.state.isAfterClientLastActive;
    const isMEVRecurring = this.props.clientStatusType == IMPLEMENTATION.value && isClientRecurring;
    const displayIsSuitableForInternationalMembers = (this.props.isInternationalFeatureEnabledForRecurring && isClientRecurring) || !isClientRecurring;
    
    return (
      <form onSubmit={this.props.handleSubmit}>
        <fieldset disabled={this.getViewOnlyForClientStatusType()}>
          <div className="sub-group">
            {isAfterClientLastActive && (
              <MessageBox className="alert-danger">
                <FormattedMessage id={potentialInactivationErrKey} />
              </MessageBox>
            )}
            <Field
              id="billingPeriodId"
              name="billingPeriodId"
              sortOptions={false}
              component={SelectInput}
              required={true}
              options={billingPeriods}
              disabled={this.props.isArchived}
              props={{ onChange: this.onBillingPeriodSelect }}
              label={<FormattedMessage id="clientCoverages.form.startDate" />}
            />
            {this.props.initialValues.clientCoverageId &&
              !isAfterClientLastActive && !this.props.fetchingMaximumRetroactiveDate && (
                <MessageBox key="startDateWarning" className="alert-warning">
                  {isMEVRecurring ?
                    <FormattedMessage id="clientCoverages.form.warnings.startDateGeneric" />
                    :
                    (
                      maximumRetroactiveDate ?
                        <FormattedMessage id="clientCoverages.form.warnings.startDateForRecurring" values={{ date: maximumRetroactiveDate }} />
                        :
                        isClientRecurring ?
                          <FormattedMessage id="clientCoverages.form.warnings.startDate" />
                          :
                          <FormattedMessage id="clientCoverages.form.warnings.startDateGeneric" />
                    )
                  }
                </MessageBox>
              )}
            <Field
              id="description"
              name="description"
              component={TextInput}
              type="text"
              disabled={this.props.isArchived || isAfterClientLastActive}
              label={<FormattedMessage id="clientCoverages.form.description" />}
            />
            <Field
              props={{ onChange: this.onGuaranteeSelect }}
              id="guaranteeId"
              name="guaranteeId"
              component={SelectInput}
              required={true}
              disabled={this.props.isArchived || isAfterClientLastActive}
              options={guarantees}
              label={<FormattedMessage id="clientCoverages.form.guaranteeName" />}
            />
            <Field
              props={{ onChange: this.onInsurerSelect }}
              id="insurerId"
              name="insurerId"
              component={SelectInput}
              required={true}
              disabled={this.props.isArchived || isAfterClientLastActive}
              options={insurers}
              label={<FormattedMessage id="clientCoverages.form.insurerName" />}
            />

            {this.generateLocalizedFields()}
            <Field
              id="policyNumber"
              name="policyNumber"
              component={TextInput}
              type="text"
              required={!this.state.clientMev}
              disabled={
                !this.state.policyNumberAvailable || isAfterClientLastActive || this.props.isArchived
              }
              props={{ onChange: this.onChangePolicyNumber }}
              label={<FormattedMessage id="clientCoverages.form.policyNumber" />}
            />
            <Field
              id="ageOfPolicyExpiration"
              name="ageOfPolicyExpiration"
              component={TextInput}
              required={true}
              type="absNumber"
              disabled={this.props.isArchived || isAfterClientLastActive}
              label={
                <FormattedMessage id="clientCoverages.form.ageOfPolicyExpiration" />
              }
            />
            <Field
              id="ageOfPolicyDecrease"
              name="ageOfPolicyDecrease"
              component={TextInput}
              required={true}
              type="absNumber"
              disabled={this.props.isArchived || isAfterClientLastActive}
              label={
                <FormattedMessage id="clientCoverages.form.ageOfPolicyDecrease" />
              }
            />
            <Field
              id="percentageOfPolicyDecrease"
              name="percentageOfPolicyDecrease"
              component={TextInput}
              required={true}
              type="absNumber"
              disabled={this.props.isArchived || isAfterClientLastActive}
              label={
                <FormattedMessage id="clientCoverages.form.percentageOfPolicyDecrease" />
              }
            />
            <Field
              id="taxType"
              name="taxType"
              component={SelectInput}
              options={clientCoverageTaxTypes}
              addBlankOption={true}
              required={true}
              sortOptions={false}
              disabled={this.props.isArchived || isAfterClientLastActive}
              label={
                <FormattedMessage id="clientCoverages.form.applicableTaxes" />
              }
            />
            {this.state.guaranteeType === PRICE_LIST.value && (
              <Field
                id="tpaTaxType"
                name="tpaTaxType"
                component={SelectInput}
                options={clientCoverageTaxTypes}
                addBlankOption={true}
                required={true}
                sortOptions={false}
                disabled={this.props.isArchived || isAfterClientLastActive}
                label={
                  <FormattedMessage id="clientCoverages.form.applicableTpaTaxes" />
                }
              />
            )}
            {displayIsSuitableForInternationalMembers && (
              <Field
                id="suitableForInternationalMembers"
                name="suitableForInternationalMembers"
                component={CheckboxInput}
                checkbox={{ value: true }}
                label={
                  <FormattedMessage id="clientCoverages.form.suitableForInternationalMembers" />
                }
                disabled={this.props.isArchived || isAfterClientLastActive}
                normalize={(value) => !!value}
              />
            )}

            <div className="pourcent">
              <Field
                id="commissionRate"
                name="commissionRate"
                component={TextInput}
                required={true}
                type="absNumber"
                label={
                  <FormattedMessage id="clientCoverages.form.commissionRate" />
                }
                disabled={this.props.isArchived || isAfterClientLastActive}
                onBlur={this.onChangeCommission}
              />
            </div>

            <div className="form-group">
              <label className="control-label">
                <span>
                  {" "}
                  {
                    <FormattedMessage
                      id={`clientCoverages.form.surplusAllocation`}
                    />
                  }
                </span>
              </label>
              <div className="input-wrapper">
                <div className="input">
                  <SurplusAllocationTable
                    onChangeRate={this.onChangeRate}
                    readOnly={isAfterClientLastActive || this.props.isArchived}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="sub-group">
            {this.props.isArchived
              ? ""
              : this.getCoverageType(this.state.guaranteeType)}
          </div>
        </fieldset>
      </form>
    );
  }
}

BasicClientCoveragesFields.propTypes = {
  scene: PropTypes.string,
  validation: PropTypes.object,
  handleSubmit: PropTypes.func,
  billingPeriodsList: PropTypes.array,
  guaranteesList: PropTypes.array,
  insurersList: PropTypes.array,
  classesList: PropTypes.array,
  dataActions: PropTypes.object,
  authLanguageCode: PropTypes.string,
  initialValues: PropTypes.object,
  clientCoveragePriceList: PropTypes.array,
  clientCoverageBillingPeriodId: PropTypes.number,
  clientLastActiveDate: PropTypes.string,
  setBlockInactivationSubmission: PropTypes.func,
  changeFieldValue: PropTypes.func,
  gotClasses: PropTypes.bool,
  ratePeriodType: PropTypes.string,
  clientRate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  commissionRate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  markUpRate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  clientStatusType: PropTypes.string,
  clientBillingPeriodType: PropTypes.string,
  isArchived: PropTypes.bool,
  billingPeriodId: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  add: PropTypes.bool,
  active: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
  ]),
  maximumRetroactiveDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  fetchingMaximumRetroactiveDate: PropTypes.bool,
};

BasicClientCoveragesFields.defaultProps = {
  scene: "",
};

BasicClientCoveragesFields.contextTypes = {
  intl: intlShape,
};

BasicClientCoveragesFields.childContextTypes = {
  scene: PropTypes.string,
};

function mapStateToProps(state) {
  const selector = formValueSelector(formName);

  const billingPeriodsData = state.data.billingPeriods || {};
  const guaranteesData = state.data.guarantees || {};
  const insurersData = state.data.insurers || {};
  const classesData = state.data.classes || {};
  const clientCoveragePricesData = state.priceList || {};
  const ratePeriodType = state.data.clients.active.ratePeriodType;
  const activeClient = state.data.clients.active;

  return {
    authLanguageCode: state.auth.user.languageCode,
    billingPeriodsList: billingPeriodsData.items || [],
    guaranteesList: guaranteesData.items || [],
    insurersList: insurersData.items || [],
    classesList: classesData.items || [],
    gotClasses: classesData.fetched,
    clientCoveragePriceList: clientCoveragePricesData.items || [],
    ratePeriodType: ratePeriodType,
    billingPeriodId: selector(state, "billingPeriodId"),
    clientRate: selector(state, "clientRate"),
    commissionRate: selector(state, "commissionRate"),
    markUpRate: selector(state, "markUpRate"),
    clientStatusType: activeClient.clientStatusType,
    clientBillingPeriodType: activeClient.clientBillingPeriodType,
    isArchived: activeClient.isArchived,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dataActions: bindActionCreators(dataActions, dispatch),
    changeFieldValue: bindActionCreators(changeFieldValue, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps, null, {
  withRef: true,
})(
  reduxForm({
    form: formName,
    validate: (values) =>
      validationUtils.validate(
        values,
        BasicClientCoveragesFields.generateLocalizedRules(values)
      ),
  })(BasicClientCoveragesFields)
);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/client-coverages/BasicClientCoveragesFields.js